import { scoreColor } from "../lib/format";

export function ScoreBar({ label, value }) {
  if (!value) return null;
  return (
    <div data-testid={`score-${label.toLowerCase().replace(/\s/g, "-")}`}>
      <div className="flex justify-between text-sm mb-1">
        <span className="text-slate-600">{label}</span>
        <span className={`font-semibold ${scoreColor(value)}`}>{value.toFixed(1)}</span>
      </div>
      <div className="h-2 rounded-full bg-slate-100 overflow-hidden">
        <div className="h-full rounded-full bg-indigo-600 transition-all duration-700" style={{ width: `${(value / 10) * 100}%` }} />
      </div>
    </div>
  );
}

export function BigScore({ value }) {
  return (
    <div className="flex items-center gap-4">
      <div className="w-20 h-20 rounded-2xl bg-indigo-900 text-white flex flex-col items-center justify-center">
        <span className="font-heading font-extrabold text-2xl leading-none">{value}</span>
        <span className="text-[10px] opacity-80">/ 10</span>
      </div>
      <div>
        <div className="font-heading font-bold text-slate-900 text-lg">Our Property Score</div>
        <div className="text-sm text-slate-500">Based on our on-ground inspection</div>
      </div>
    </div>
  );
}
